import React from 'react'
import { connect } from 'react-redux'
import classNames from 'classnames'
import { compose } from 'recompose'

import { setLanguage } from '../../../actions/info'
import { withTranslation } from 'react-i18next'

class LangSelect extends React.Component {
  state = {
    language: this.props.language,
  }

  async componentDidMount() {
    const language = await localStorage.getItem('language')
    this.props.setLanguage(language || 'th')
    this.props.i18n.changeLanguage(language || 'th')
  }

  static getDerivedStateFromProps(props, state) {
    if (props.language !== state.language) {
      return {
        language: props.language,
      }
    }
    return null
  }
  handleChange = ({ target: { value: language } }) => {
    this.setState({ language })
    this.props.setLanguage(language)
    this.props.i18n.changeLanguage(language)
    localStorage.setItem('language', language)
  }

  render() {
    return (
      <div className="field">
        <div className={classNames('control', { 'has-icons-left': true })}>
          <LangSelectView
            onChange={this.handleChange}
            language={this.state.language}
          />
          <div className="icon is-small is-left">
            <i className="fas fa-globe" />
          </div>
        </div>
      </div>
    )
  }
}

export const LangSelectView = ({ onChange, language }) => (
  <div className="select">
    <select onChange={onChange} value={language}>
      <option value="th">ภาษาไทย</option>
      <option value="en">English</option>
      <option value="zh">Chinese</option>
    </select>
  </div>
)

export default compose(
  connect(
    ({ info: { language } }) => ({ language }),
    { setLanguage: setLanguage },
  ),
  withTranslation(),
)(LangSelect)



// WEBPACK FOOTER //
// ./src/components/templates/lang-select/LangSelect.js